module.exports = __webpack_public_path__ + "media/src/images/icons/white-plus-80851073e62c667da1fb6d9fb6bac047.svg";